import React from 'react';
import { Navigate } from 'react-router';

import { UNGROUPED_RESOURCES_GROUP_ID } from '@/shared/features/groups/components/group-list/group-list.constants';
import { useGroupShellConfig } from '@/shared/features/groups/components/group-list/group-shell-context';
import { TLastGroupRedirectProps } from '@/shared/features/groups/components/last-group-redirect/last-group-redirect.types';
import { useGroupTreeStorage } from '@/shared/features/groups/hooks/use-group-tree-storage/use-group-tree-storage';
import { findGroupInTree } from '@/shared/features/groups/utils/group-hierarchy/find-group-in-tree';

export const LastGroupRedirect: React.FC<TLastGroupRedirectProps> = ({
  fallback,
}) => {
  const { useTreeItems, groupRoutePath } = useGroupShellConfig();
  const { data: groups, isLoading } = useTreeItems();
  const { readLastGroup } = useGroupTreeStorage();
  const lastGroup = readLastGroup();

  // A path stored under an older route shape no longer leads anywhere.
  if (!lastGroup?.path.startsWith(`${groupRoutePath}/`)) {
    return fallback;
  }

  // Resuming into a group that was deleted, or that the reader has since lost
  // access to, would answer a sidebar click with an error page.
  if (isLoading) {
    return null;
  }

  const canResume =
    lastGroup.groupId === UNGROUPED_RESOURCES_GROUP_ID ||
    findGroupInTree(groups, lastGroup.groupId);

  if (!canResume) {
    return fallback;
  }

  return <Navigate to={lastGroup.path} replace />;
};
